import React, { useEffect, useState } from "react";
import styles from "./../styles.module.scss";
import { Button, FilterDropdown, TextInput } from "components";
import { useDispatch, useSelector } from "react-redux";
import { subCategoriesAction, classSessionAction } from "redux/actions";
import axios from "axios";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";
import {adminToken, internalSearch} from "../../../../helper";

export default function EditSessionDetails({ onClick, details, package_id, setDetails }) {
  const dispatch = useDispatch();
  const classSession = useSelector(state => state.classSession)
  const [spLoader, setSpLoader] = useState(false);
  const [serviceProviderlist, setServiceProviderlist] = useState([])
  const {userRole} = useSelector(state => ({
      userRole: state.userRole?.filter(role => role.module === "Service Provider")
  }));


  useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")) {
          setSpLoader(true);
          adminToken().then(token => axios
              .get(
                  `${AWS_SERVER_APIS}/getspbycat?package_id=${package_id}`,
                  {
                      headers: {
                          Authorization: `Bearer ${token}`
                      }
                  }
              )
              .then(res => {
                  const uniqueSP = res.data.data.filter(
                    (data, index, self) =>
                      index === self.findIndex(u => u.id === data.id)
                  );
                  setServiceProviderlist(uniqueSP);
                  setSpLoader(false);
              })
          )
        }
      // dispatch(classSessionAction.getsplist());
    }, []);
  
    

  return (
    <div className={styles.main__container}>

      <TextInput
        label="Class Date"
        placeholder="Class Date"
        name="class_date"
        onChange={setDetails}
        value={details?.class_date}
        type="date"
        min="0"
      />

      <TextInput
          label="Class Time"
          placeholder="Class Time"
          name="class_time"
          onChange={setDetails}
          value={details?.class_time}
          type="time"
        />

    <FilterDropdown
      label="Service Provider"
      name="sp_id"
      onChange={ e => {
        setDetails(e);
      }}
      value={details?.sp_id}
      options={
        serviceProviderlist?.length
          ? ["Pick a Service Provider", ...serviceProviderlist?.map(item => item.first_name+' '+item.last_name)]
          : ["Pick a Service Provider"]
      }
      values={
        serviceProviderlist?.length
          ? [0, ...serviceProviderlist?.map(item => item.id)]
          : [0]
      }
    />

    {/* <TextInput
        label="Provider"
        placeholder="Provider"
        name="sp_id"
        onChange={setDetails}
        value={details?.sp_id}
        type="text"
        min="0"
      /> */}

    <TextInput
        label="Join URL"
        placeholder="Join URL"
        name="join_url"
        onChange={setDetails}
        value={details?.join_url}
        type="text"
        min="0"
      />

    <FilterDropdown
        label="Status"
        name="status"
        onChange={e => {
            setDetails(e);
        }}
        value={details?.status}
        options={
            ["scheduled","cancelled","completed"]
        }
        values={
            ["scheduled","cancelled","completed"]
        }
    />
      

      <div className={styles.btn__container}>
        <Button title="Update" onClick={onClick} />
      </div>
    </div>
  );
}
